import { maskPhoneNumber } from '@utils/utils';

export function getMaskedOrUnmaskedData(maskData: boolean, bankAccountNo: string): string {
  return maskData ? maskPhoneNumber(bankAccountNo) : bankAccountNo;
}

export function setMaskIconValue(maskData: boolean): string {
  return maskData ? 'eye' : 'eye-off';
}

export function setIconValue(icon: string): string {
  return icon === 'up' ? 'down' : 'up';
}

export function getIconState(expanded: boolean): string {
  return expanded ? 'up' : 'down';
}

export function maskIconInit(maskData: boolean): string {
  return maskData ? 'eye-off' : 'eye';
}
